import React, { useState } from 'react';
import PaginatedTable from '../../commonComponents/PaginatedTable';
import { Input, Button, notification, Tooltip, message, Modal, Typography } from 'antd';
import { EyeOutlined, DeleteOutlined, LinkOutlined, CopyOutlined, CheckOutlined } from '@ant-design/icons';
import PlusIconActionButton from '../PlusIconActionButton';
import ShareDetails from './ShareDetails';
import CreateShootMergeGuideline from './create';
import style from './index.scss';
import useLogout from '../../hooks/useLogout';
import ShowMergedLinks from './ShowMergedLinks';
import {
    useAddGuidelinesToInventorySession,
    useCreateMergedGuidelinesForShoot,
    useDeleteMergeGuidelineForShoot,
    useGetMergedGuidelinesForShoot,
} from '../../hooks/useShootMergeGuideline';
import DebounceInput from '../../commonComponents/DebounceInput';
import RackLabelsTitle from './RackLabelsTitle';

const PREPARE_INVENTORY_BASE_URL = 'https://master.d2aa62ygg90qvn.amplifyapp.com/';
const getPrepareInventoryLink = sessionId => `${PREPARE_INVENTORY_BASE_URL}?prepareInventorySessionId=${encodeURIComponent(sessionId)}`;

export default function ShootPrepartionGuidelines() {
    const [api, contextHolder] = notification.useNotification();
    const [showCreate, setShowCreate] = useState(false);
    const [selectedGuideline, setSelectedGuideline] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showGuidelineLinks, setShowGuidelineLinks] = useState(false);
    const [shareDetail, setShareDetail] = useState(false);
    const [inventoryLinkRecord, setInventoryLinkRecord] = useState(null);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchText, setSearchText] = useState('');
    const { logout } = useLogout();
    const DeleteMergeGuidelineMutationForShoot = useDeleteMergeGuidelineForShoot();
    const { data, isFetching, isFetched, refetch: refetchMergedGuidelinesForShoot } = useGetMergedGuidelinesForShoot(pageNum, pageSize, searchText);
    const CreateMergedShootGuidelinesMutation = useCreateMergedGuidelinesForShoot();
    const AddGuidelinesMutation = useAddGuidelinesToInventorySession();

    const OnChangePaginator = (num, size) => {
        setPageNum(num);
        setPageSize(size);
    };

    const HandleCreationClose = () => {
        setShowCreate(false);
        setSelectedGuideline(null);
    };

    const HandleCreation = async data => {
        setLoading(true);
        const { links, name, teamLead } = data;

        CreateMergedShootGuidelinesMutation.mutateAsync([links, name, teamLead])
            .then(() => {
                console.log('Success');
                api.success({
                    message: 'Successfully created',
                });
            })
            .catch(error => {
                api.error({
                    message: 'Failed To Create Merged Guideline',
                    duration: 3,
                    description: JSON.parse(error?.response?.data).message,
                });
                console.log(JSON.parse(error?.response?.data).message);
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setLoading(false);
                setShowCreate(false);
                refetchMergedGuidelinesForShoot();
            });
    };

    const ShareGuidelineToUsers = async link => {
        // setLoading(true);
        // AddLinkToGuidelineMutation.mutateAsync([selectedGuideline?._id, link])
        //     .then(() => {
        //         api.success({
        //             message: 'Successfully Added Link to Guideline',
        //         });
        //     })
        //     .catch(error => {
        //         api.error({
        //             message: 'Failed To Create Add Barcode',
        //             duration: 3,
        //             description: JSON.parse(error?.response?.data).message,
        //         });
        //         console.log(JSON.parse(error?.response?.data).message);
        //         if (error?.response?.status === 401) logout();
        //     })
        //     .finally(() => {
        //         setLoading(false);
        //         setShowAddLink(false);
        //         refetchMergedGuidelinesForShoot();
        //     });
    };

    const HandleDeleteGuidelineForShoot = async guideline => {
        const sessionId = guideline?.sessionId;
        const isActive = false;
        setLoading(true);
        DeleteMergeGuidelineMutationForShoot.mutateAsync([sessionId])
            .then(resp => {
                if (resp?.status === 200) {
                    api.success({
                        message: 'Successfully removed session!',
                    });
                }
            })
            .catch(error => {
                console.log(error);
                message.error(error?.response?.data?.message || 'Error!');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setLoading(false);
                refetchMergedGuidelinesForShoot();
            });
    };

    const Actions = ({ record }) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                    }}
                >
                    <Tooltip title="Show Merged Guideline links">
                        <Button
                            onClick={() => {
                                setShowGuidelineLinks(true);
                                setSelectedGuideline(record);
                            }}
                            style={{ background: '#F9F3F3' }}
                        >
                            <EyeOutlined />
                        </Button>
                    </Tooltip>

                    <Tooltip title="Prepare Inventory link">
                        <Button
                            disabled={!record?.sessionId}
                            onClick={() => setInventoryLinkRecord(record)}
                            style={{ background: '#F9F3F3' }}
                        >
                            <LinkOutlined />
                        </Button>
                    </Tooltip>

                    <Tooltip title="Delete">
                        <Button
                            onClick={() =>
                                Modal.confirm({
                                    title: 'Delete session?',
                                    content: `Are you sure you want to delete "${record?.name || record?.sessionId}"? This cannot be undone.`,
                                    okText: 'Delete',
                                    okType: 'danger',
                                    cancelText: 'Cancel',
                                    onOk: () => HandleDeleteGuidelineForShoot(record),
                                })
                            }
                            style={{ background: '#F9F3F3' }}
                        >
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </div>
            </>
        );
    };

    const columns = [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: 'Team lead',
            key: 'teamLead',
            dataIndex: 'teamLead',
            render: (value) => value || '—',
        },
        {
            title: 'Session ID',
            key: 'sessionId',
            dataIndex: 'sessionId',
        },
        {
            title: 'Created By',
            key: 'createdBy',
            render: (_, record) => {
                return <p>{record?.createdBy?.name}</p>;
            },
        },
        {
            title: 'Created At',
            key: 'createdAt',
            render: (_, record) => {
                return (
                    record?.createdAt && (
                        <p>{`${new Date(record?.createdAt).toLocaleString('en-GB', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hourCycle: 'h12',
                        })}`}</p>
                    )
                );
            },
        },

        {
            title: 'Action',
            key: 'actions',
            render: (_, record) => <Actions record={record} />,
            width: '15%',
        },
    ];

    const inventoryLink = inventoryLinkRecord ? getPrepareInventoryLink(inventoryLinkRecord.sessionId) : '';

    return (
        <>
            {contextHolder}
            <div className="filter_div">
                <div className="search_name_filter">
                    <label htmlFor="">Name: </label>
                    <DebounceInput
                        searchName={searchText}
                        setSearchName={setSearchText}
                        style={{ minWidth: '125px' }}
                        placeholder="Search by Name"
                        size="small"
                    />
                </div>
            </div>
            <div className="table_main_dev">
                <PaginatedTable
                    dataSource={data?.data}
                    columns={columns}
                    isFetching={isFetching}
                    total={data?.totalCount}
                    OnChangePaginator={OnChangePaginator}
                    defaultPageSize={20}
                    pageNum={pageNum}
                    pageSize={pageSize}
                    key="MergedGuidelineList"
                    height="calc(100vh - 150px)"
                />
            </div>
            <PlusIconActionButton title="Create New Session" onClick={() => setShowCreate(true)} />

            {!!shareDetail && !!selectedGuideline && (
                <ShareDetails
                    onCancel={() => {
                        setShareDetail(false);
                        setSelectedGuideline(null);
                    }}
                    open={shareDetail}
                    title={`${selectedGuideline?.name}`}
                    loading={loading}
                    updateGuideline={ShareGuidelineToUsers}
                />
            )}
            {!!showGuidelineLinks && !!selectedGuideline && (
                <ShowMergedLinks
                    onCancel={() => {
                        setShowGuidelineLinks(false);
                        setSelectedGuideline(null);
                    }}
                    open={showGuidelineLinks}
                    title={`Merged Guidelines`}
                    loading={loading}
                    data={selectedGuideline}
                    onAddLinks={async (links) => {
                        const res = await AddGuidelinesMutation.mutateAsync([selectedGuideline.sessionId, links]);
                        const updated = res?.data || res;
                        if (updated) setSelectedGuideline(updated);
                        refetchMergedGuidelinesForShoot();
                    }}
                />
            )}
            {!!inventoryLinkRecord && (
                <Modal
                    open={!!inventoryLinkRecord}
                    title={<RackLabelsTitle title="Prepare Inventory Link" mergeIds={inventoryLinkRecord.mergeIds} />}
                    footer={null}
                    onCancel={() => setInventoryLinkRecord(null)}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Typography.Link
                            href={inventoryLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ flex: 1, minWidth: 0, wordBreak: 'break-all' }}
                        >
                            {inventoryLink}
                        </Typography.Link>
                        <Typography.Text
                            copyable={{
                                text: inventoryLink,
                                icon: [<CopyOutlined key="copy" style={{ color: '#000' }} />, <CheckOutlined key="copied" style={{ color: '#52c41a' }} />],
                            }}
                        />
                    </div>
                </Modal>
            )}
            {showCreate && (
                <CreateShootMergeGuideline
                    HandleOnOK={HandleCreation}
                    loading={loading}
                    onCancel={HandleCreationClose}
                    showCreate={showCreate}
                    key="CreateMergedShootLink"
                    name={selectedGuideline?.name}
                    description={selectedGuideline?.description}
                    links={selectedGuideline?.links}
                    validatedLinks={selectedGuideline?.validatedLinks}
                />
            )}
        </>
    );
}

//  <Tooltip title="Share Session Details">
//      <Button
//          onClick={() => {
//              setShareDetail(true);
//              setSelectedGuideline(record);
//          }}
//          style={{ background: '#F9F3F3' }}
//      >
//          <MailOutlined />
//      </Button>
//  </Tooltip>;
